"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_grid_system_1 = require("react-grid-system");
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    xs: {
        marginBottom: theme.gutters.xs,
    },
    sm: {
        marginBottom: theme.gutters.sm,
    },
    md: {
        marginBottom: theme.gutters.md,
    },
    lg: {
        marginBottom: theme.gutters.lg,
    },
    xl: {
        marginBottom: theme.gutters.xl,
    },
    xxl: {
        marginBottom: theme.gutters.xxl,
    },
}); });
var Row = function (props) {
    var styles = useStyles();
    var screenClass = (0, react_grid_system_1.useScreenClass)();
    return (react_1.default.createElement(react_grid_system_1.Row, __assign({}, props, { nogutter: props.noGutters, wrap: props.noWrap ? 'nowrap' : 'wrap', className: (0, classnames_1.default)(styles[screenClass], props.className) })));
};
exports.default = Row;
//# sourceMappingURL=Row.js.map